<template lang="pug">
  button.button-delete(
  @click.prevent.stop="$emit('onButtonClick')"
  )
    img.button-delete__icon(src="@/assets/images/icons/cross.svg")
    img.button-delete__icon.button-delete__icon_hover(src="@/assets/images/icons/cross-dark.svg")
</template>

<script>
export default {
  name: "button-delete",
};
</script>
